<template>
  <div class="pop">
    <div class="bg-in">
      <img
        src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/a90ehq6h5deabx8br5yzyd5lyiuua9kupop.png"
        style="width:90vw; height: auto; border-radius: 10px"
        @click="goToPromotion"
        alt="">
      <div class="cancel-btn" v-show="delayedAWhile" @click="close">
        <img :src="cancelWhite" alt="cancel">
      </div>
    </div>
  </div>
</template>

<script>
import cancelWhite from '@/assets/images/common/cancelWhite.svg'
import IFrame3Part from '@/components/IFrame3Part/index'
import {closePop} from '@/utils'
export default {
  name: 'ComeOnAgent',
  props: ['handleClose'],
  data () {
    return {
      cancelWhite,
      iFrameSrc: '',
      showPromotion: false,
      internation: '',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      delayedAWhile: true
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.onInit()
    }
  },
  components: {
    IFrame3Part
  },
  mounted () {
    if (localStorage.getItem('locale') === 'IN') {
      this.internation = 'IN'
      this.iFrameSrc = 'https://www.jlfafafa3.com/hi-IN/action/20230822S/slot'
    } else {
      this.internation = 'INT'
      this.iFrameSrc = 'https://www.jlfafafa3.com/action/20230822S/slot'
    }
    this.onInit()
  },
  methods: {
    onInit: function () {
      // let that = this
      // setTimeout(() => {
      //   that.delayedAWhile = true
      //   return null
      // }, 3000)
    },
    close () {
      this.handleClose()
    },
    goToPromotion () {
      closePop(13)
      this.$router.push('/Landing4')
    },
    handleCloseIFrame3Part () {
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
  .pop {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,.6);
    z-index: 9;
    padding: 40px 20px;
    box-sizing: border-box;
    overflow: auto;

    .bg-in {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100vw;

      .cancel-btn {
        width: 7vw;
        height: 7vw;
        margin-top: 3.5vw;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ComeOnAgent/index.vue